import React, { useState, useEffect } from 'react';
import { HeaderContainer, HeaderContent } from './styles';
import HeaderTabs from './HeaderTabs';
import SideMenu from './SideMenu';
import { ERoutes } from '../../routes';
import { useHistory, useLocation } from 'react-router-dom';
import useIsScreenSmallerThan from '../../hooks/useIsScreenSmallerThan';
import useIsBusinessTypeCG from '../../hooks/useIsBusinessTypeCG';
import theme from '../../assets/styles/theme/theme';
import { Header as HefestoHeader } from '@gerdau/hefesto-mais-web/Header';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { EPurchaseRoutes } from '../Purchase/purchase.routes';
import { EOrderSettingsRoutes } from '../Purchase/LongSteel/OrderSettings/orderSettings.routes';
import {
  swapCustomerViewType,
  userLogout
} from '../../store/ducks/user/actions';
import { ECustomerTypeView, EResearchNps } from '../../store/ducks/user/types';
import { sendTagging } from '../../store/ducks/tagging/actions';
import EGerdauSurvey from './EGerdauSurvey';
import { GetFlag } from '../../utils/featureFlag';
import { Variants } from '@gerdau/hefesto/_shared/types';
import { ELoyaltyRoutes } from '../Loyalty/loyalty.routes';
import { loadLoyaltyRewards } from '../../store/ducks/loyalty/actions';
import GerdauProVideoModal from '../../components/GerdauProVideoModal';
import { JourneySurvey } from '../Purchase/LongSteel/CheckoutMVP/JourneySurvey';
import { useNavigationGuard } from '../../providers/navigationguard.provider';
import { GuardianCartModal } from '../../components/GuardianCartModal';
import useModalPriority, {
  ModalPriorities
} from '../../hooks/useModalPriority';
import { useCart } from '../Purchase/LongSteel/ShoppingCartMVP/useCart';
import { useCartService } from '../../services/MVP/useCartService';
import useIsCommerceUser from '../../hooks/useIsCommerceUser';
import AbandonedCartReminder from '../../components/AbandonedCartReminder';

interface IOptions {
  text: string;
  handleOnClick: () => void;
  icon?: JSX.Element;
  variant?: Extract<Variants, 'danger' | 'primary'>;
  disabled?: boolean;
}

const Header: React.FC = () => {
  const dispatch = useDispatch();

  const releaseToggleNPS = GetFlag('release-toggle-enable-nps');
  const gerdauProModalFlag = GetFlag('gerdal-pro-modal');
  const newCartEndpoint = GetFlag('new_cart_endpoints');
  const abandonedCartFlag = GetFlag('abandoned_cart');

  const { deleteCartId } = useCart();
  const { deactivateCart } = useCartService();

  const navigationGuard = useNavigationGuard();

  const history = useHistory();
  const { pathname } = useLocation();

  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState<ERoutes>();

  // const [showNotifications, setShowNotifications] = useState(false);

  const [notificationWasClicked, setNotificationWasClicked] = useState(false);

  const canShowSideMenuButton = useIsScreenSmallerThan(
    Number(theme.breakpoints.tablet.replace('px', ''))
  );

  const userState = useSelector((state: ApplicationState) => state.user);
  const customerViewType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );

  const shoppingCartItems = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart.items.length || 0
  );

  const cartQuantity = useSelector(
    (state: ApplicationState) => state.cartItemsMvp?.quantity || 0
  );
  const totalNotifications = useSelector(
    (state: ApplicationState) =>
      state.notifications.newContractNotifications?.length || 0
  );

  const {
    longSteelOrders,
    fabricationOrders,
    invoices,
    fabricationContracts,
    customers
  } = useSelector((state: ApplicationState) => state);

  const isSoldToView = useSelector(
    (state: ApplicationState) =>
      state.user.searchCustomerType === ECustomerTypeView.EMITTER
  );

  const user = useSelector((appState: ApplicationState) => appState.user);
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const menu_superior_loyalty = GetFlag('menu_superior_loyalty');
  const campanha_loyalty_geral = GetFlag('campanha_loyalty_geral');
  const isLoyaltyUser = user.userPermissions.hasLoyaltyAccess;
  const hasLoyaltyAccess = isLoyaltyUser && campanha_loyalty_geral;
  const aba_resgate = GetFlag('aba_resgate');
  const aba_meus_pontos = GetFlag('aba_meus_pontos');
  const aba_como_funciona = GetFlag('aba_como_funciona');
  const aba_simulador = GetFlag('aba_simulador');
  const jornada_vendedor = GetFlag('jornada_vendedor');
  const favorite_product = GetFlag('favorite_product');

  const isEmitter = customerViewType === ECustomerTypeView.EMITTER;
  const isMVPUser = useIsCommerceUser();
  const isBusinessTypeCG = useIsBusinessTypeCG();

  const cartItemsCount = isMVPUser ? cartQuantity : shoppingCartItems;

  useEffect(() => {
    if (
      hasLoyaltyAccess &&
      !loyalty.rewards.loading &&
      !loyalty.rewards.error &&
      user.roles.loyaltyCustomers
    ) {
      dispatch(loadLoyaltyRewards(user.roles.loyaltyCustomers));
    }
  }, [hasLoyaltyAccess]);

  const prepareAndSendTagging = (itemName: string, itemDescription: string) => {
    const lastScreenName = window.dataLayer
      .filter((data: { event: string }) => data.event === 'page_view')
      .pop()?.screenName;

    dispatch(
      sendTagging({
        screenName: lastScreenName,
        event: 'click',
        itemName: itemName,
        itemDescription: itemDescription
      })
    );
  };

  // const onClickNotification = () => {
  //   navigationGuard.handleCallFunctions({
  //     action: () =>
  //       (() => {
  //         setShowNotifications(true);
  //         setNotificationWasClicked(true);
  //         prepareAndSendTagging('button:notificacao', 'header_notificacao');
  //       })(),
  //     hasItemOnCart: cartItemsCount > 0
  //   });
  // };

  const getShoppingCartLinkTo = (): void => {
    if (isEmitter && isMVPUser) {
      return history.push(
        `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/commerce/${EOrderSettingsRoutes.SHOPPING_CART}`
      );
    }

    prepareAndSendTagging('button:carrinho', 'header_carrinho');
    if (shoppingCartItems > 0) {
      history.push(
        `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}${''}/${
          EOrderSettingsRoutes.SHOPPING_CART
        }`
      );
    } else {
      history.push(`${ERoutes.PURCHASE}`);
    }
  };

  const handleAccessHelpCenterClick = () => {
    prepareAndSendTagging('button:ajuda', 'header_ajuda');
    navigationGuard.handleNavigation({
      path: ERoutes.HELP_CENTER,
      hasItemOnCart: cartItemsCount > 0
    });
  };

  const handleAccessManagementClick = () => {
    prepareAndSendTagging('button:gestao_usuarios', 'header_gestaoUsuarios');
    navigationGuard.handleNavigation({
      path: ERoutes.ACCESS_MANAGEMENT,
      hasItemOnCart: cartItemsCount > 0
    });
  };

  const handleAccessInternalManagementClick = () => {
    // TODO TAGGING
    // prepareAndSendTagging('button:gestao_usuarios', 'header_gestaoUsuarios');
    navigationGuard.handleNavigation({
      path: ERoutes.ACCESS_INTERNAL_MANAGEMENT,
      hasItemOnCart: cartItemsCount > 0
    });
  };

  const handleLoyaltyHowWorksClick = () => {
    prepareAndSendTagging('button:loyalty_how_works', 'header_loyalty');
    navigationGuard.handleNavigation({
      path: `${ERoutes.LOYALTY}${ELoyaltyRoutes.LOYALTY_HOW_WORKS}`,
      hasItemOnCart: cartItemsCount > 0
    });
  };
  const handleLoyaltyCoinsClick = () => {
    prepareAndSendTagging('button:loyalty_coins', 'header_loyalty');
    navigationGuard.handleNavigation({
      path: `${ERoutes.LOYALTY}${ELoyaltyRoutes.LOYALTY_COINS}`,
      hasItemOnCart: cartItemsCount > 0
    });
  };
  const handleLoyaltySimulatorClick = () => {
    prepareAndSendTagging('button:loyalty_simulator', 'header_loyalty');
    navigationGuard.handleNavigation({
      path: `${ERoutes.LOYALTY}${ELoyaltyRoutes.LOYALTY_SIMULATOR}`,
      hasItemOnCart: cartItemsCount > 0
    });
  };
  const handleLoyaltyRewardsClick = () => {
    prepareAndSendTagging('button:loyalty_rewards', 'header_loyalty');
    navigationGuard.handleNavigation({
      path: `${ERoutes.LOYALTY}${ELoyaltyRoutes.LOYALTY_REWARDS}`,
      hasItemOnCart: cartItemsCount > 0
    });
  };

  const handleSpecialSteelClick = () => {
    navigationGuard.handleCallFunctions({
      action: () =>
        (() => {
          prepareAndSendTagging(
            'button:acos_especiais',
            'header_acosEspeciais'
          );
          window.location.href = process.env.REACT_APP_URL_GSB as string;
        })(),
      hasItemOnCart: cartItemsCount > 0
    });
  };
  const onSwapCustomerViewType = () => {
    dispatch(swapCustomerViewType(userState));
    history.push('/');
  };

  const handleIsSoldView = () => {
    const buttonTaggingItemName = isSoldToView
      ? 'button:visao_recebedor'
      : 'button:visao_emissor';
    const buttonTaggingItemDescription = isSoldToView
      ? 'header_visaoRecebedor'
      : 'header_visaoEmissor';

    prepareAndSendTagging(buttonTaggingItemName, buttonTaggingItemDescription);

    if (
      !(longSteelOrders.loading || fabricationOrders.loading) &&
      !invoices.loading &&
      !fabricationContracts.loading &&
      !customers.loading
    ) {
      navigationGuard.handleCallFunctions({
        action: () => onSwapCustomerViewType(),
        hasItemOnCart: cartItemsCount > 0
      });
    }
  };

  const handleFavoritesClick = () => {
    prepareAndSendTagging('button:lista_favoritos', 'header_listaFavoritos');
    navigationGuard.handleNavigation({
      path: ERoutes.FAVORITES,
      hasItemOnCart: cartItemsCount > 0
    });
  };

  const handleSettingsClick = () => {
    prepareAndSendTagging('button:configuracoes', 'header_configuracoes');
    navigationGuard.handleNavigation({
      path: `${ERoutes.SETTINGS}`,
      hasItemOnCart: cartItemsCount > 0
    });
    // history.push(`${ERoutes.SETTINGS}`);
  };

  const handleLogoutClick = () => {
    navigationGuard.handleCallFunctions({
      action: () =>
        (() => {
          if (newCartEndpoint) {
            deleteCartId();
            if (!abandonedCartFlag) {
              deactivateCart();
            }
          }
          prepareAndSendTagging('button:sair_da_conta', 'header_sairDaConta');
          dispatch(userLogout());
          localStorage.removeItem('selectedProducts');
          sessionStorage.clear(); // modals save keys to sessionStorage to prevent spam it.
        })(),
      hasItemOnCart: cartItemsCount > 0
    });
  };
  const isManager = useSelector(
    (state: ApplicationState) => state.user.isManager
  );

  const getMenuLinks = (): IOptions[] => {
    const menu: IOptions[] = [];

    if (
      userState.userPermissions.hasAccessManagementAccess ||
      userState.isManager
    ) {
      menu.push({
        text: 'Gestão de usuários',
        handleOnClick: handleAccessManagementClick,
        variant: 'primary'
      });
    }

    if (jornada_vendedor) {
      menu.push({
        text: 'Gestão de usuários internos',
        handleOnClick: handleAccessInternalManagementClick,
        variant: 'primary'
      });
    }

    if (favorite_product && isMVPUser && !isBusinessTypeCG) {
      menu.push({
        text: '',
        icon: (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontStyle: 'normal'
            }}
          >
            Lista de favoritos
          </span>
        ),
        handleOnClick: handleFavoritesClick,
        variant: 'primary'
      });
    }

    if (!isManager) {
      menu.push({
        text: isSoldToView ? 'Visão de recebedor' : 'Visão de emissor',
        handleOnClick: handleIsSoldView,
        variant: 'primary'
      });
    }

    menu.push({
      text: 'Configurações',
      handleOnClick: handleSettingsClick,
      variant: 'primary'
    });

    if (userState.expecialSteel) {
      menu.push({
        text: 'Aços especiais',
        handleOnClick: handleSpecialSteelClick,
        variant: 'primary'
      });
    }
    menu.push({
      text: 'Sair da conta',
      handleOnClick: handleLogoutClick,
      variant: 'primary'
    });

    return menu;
  };
  const getCoinLinks = (): IOptions[] => {
    const menu: IOptions[] = [];
    if (aba_meus_pontos) {
      menu.push({
        text: 'Meus pontos',
        handleOnClick: handleLoyaltyCoinsClick,
        variant: 'primary'
      });
    }
    if (aba_simulador) {
      menu.push({
        text: 'Simulador',
        handleOnClick: handleLoyaltySimulatorClick,
        variant: 'primary'
      });
    }
    if (aba_resgate) {
      menu.push({
        text: 'Resgate',
        handleOnClick: handleLoyaltyRewardsClick,
        variant: 'primary'
      });
    }
    if (aba_como_funciona) {
      menu.push({
        text: 'Como Funciona?',
        handleOnClick: handleLoyaltyHowWorksClick,
        variant: 'primary'
      });
    }

    return menu;
  };
  const coinLinks = getCoinLinks();
  const menuLinks = getMenuLinks();

  useEffect(() => {
    const path = `/${pathname.split('/')[1]}` as ERoutes;
    setSelectedTab(path);
  }, [pathname]);

  useEffect(() => {
    setNotificationWasClicked(false);
  }, [totalNotifications]);

  const [showEgerdauSurvey, EgerdauSurveyActions] = useModalPriority(
    'surveyModal',
    ModalPriorities.EgerdauSurvey,
    false,
    undefined,
    true
  );

  const [showGerdalProModal, setShowGerdalProModal] = useState(false);

  useEffect(() => {
    const improvementSurveyNps =
      user?.userSurveys?.userNps?.improvementSurveyNps;
    if (
      releaseToggleNPS &&
      (!improvementSurveyNps || improvementSurveyNps === EResearchNps.PENDING)
    ) {
      EgerdauSurveyActions.open();
    }
  }, [releaseToggleNPS]);

  useEffect(() => {
    if (isEmitter && isMVPUser) {
      localStorage.setItem('nova_jornada_compras_gab', 'true');
    } else {
      localStorage.removeItem('nova_jornada_compras_gab');
    }
  }, [isEmitter, isMVPUser]);

  useEffect(() => {
    const { gerdauProModal } = user.terms;
    const { fabricationViewCustomers } = user.roles;
    const isPermission =
      fabricationViewCustomers !== null && fabricationViewCustomers.length > 0;
    if (
      isPermission &&
      gerdauProModalFlag &&
      (gerdauProModal == null || gerdauProModal === true)
    ) {
      setShowGerdalProModal(true);
    }
  }, [gerdauProModalFlag]);

  return (
    <>
      <HeaderContainer>
        <HeaderContent>
          <div>
            <HefestoHeader
              showCartIcon={userState.userPermissions.hasOrderInputAccess}
              onClickHelp={handleAccessHelpCenterClick}
              // onClickNotification={onClickNotification}
              onClickNotification={() => null}
              onClickCart={getShoppingCartLinkTo}
              cartItemsCount={cartItemsCount}
              hasNotification={
                totalNotifications > 0 && !notificationWasClicked
              }
              userName={userState.name}
              coinTotal={loyalty.rewards.total.total_coins}
              coinLinks={coinLinks}
              userGroup=""
              menuLinks={menuLinks}
              showCoinMenu={hasLoyaltyAccess && menu_superior_loyalty}
              key={cartItemsCount}
            />
          </div>

          {!canShowSideMenuButton && selectedTab && (
            <HeaderTabs
              selectedTab={selectedTab}
              onSelectTab={(tab) => setSelectedTab(tab)}
            />
          )}
          <AbandonedCartReminder />
        </HeaderContent>
      </HeaderContainer>

      {isSideMenuOpen && selectedTab && (
        <SideMenu
          setIsSideMenuOpen={setIsSideMenuOpen}
          selectedTab={selectedTab}
          onSelectTab={(tab) => setSelectedTab(tab)}
        />
      )}

      {/* {showNotifications && (
        <Notifications
          notificationIsOpen={showNotifications}
          onCloseNotifications={() => setShowNotifications(false)}
        />
      )} */}

      {showEgerdauSurvey && (
        <EGerdauSurvey
          user={user}
          onCloseModal={EgerdauSurveyActions.close}
          onDismiss={EgerdauSurveyActions.dismiss}
        />
      )}
      {showGerdalProModal && (
        <GerdauProVideoModal
          user={user}
          onCloseModal={() => setShowGerdalProModal(false)}
        />
      )}

      {navigationGuard.showModal && <GuardianCartModal />}

      <JourneySurvey user={user} />
    </>
  );
};

export default Header;
